<template>
  <div class="video-content">
    <div class="image-bg">
      <img src="../../../../assets/images/default-audio.png" alt="" />
    </div>
    <div class="title">{{ title }}</div>
    <div class="slider">
      <div class="time-left">
        {{ getTime(Math.round(value)) }}
      </div>
      <!-- disabled -->
      <van-slider
        v-model="value"
        bar-height="6"
        active-color="#479bd8"
        inactive-color="#999999"
        button-size="18"
        @change="onChange"
        :max="totalTime"
      />
      <div class="time">
        {{ getTime(Math.round(totalTime)) }}
      </div>
    </div>
    <div class="buttn-box">
      <div class="ply-btn" @click="play()">
        <img
          :src="
            require('../../../../assets/icon/' +
              (!playState ? 'play.png' : 'player.png'))
          "
          alt=""
        />
      </div>
    </div>
    <div class="abstract">
      <span>简介</span>
    </div>
    <div class="remark" v-html="remark ? remark : '暂无'"></div>
    <!-- <div class="remark">{{ remark ? remark : "暂无" }}</div> -->
    <audio
      v-show="false"
      :src="url"
      controls="controls"
      ref="videoPlayer"
      @play="onPlayerPlay($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @ended="onPlayerEnded"
    ></audio>
    <!-- <video-player
      v-show="false"
      class="video-player vjs-custom-skin vjs-big-play-centered"
      :options="playerOptions"
      ref="videoPlayer"
      @play="onPlayerPlay($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @ended="onPlayerEnded"
      @canplay="canplay($event)"
    ></video-player> -->
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  components: { videoPlayer },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当 true 时，Video.js player 将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: this.url, // 路径
            type: "audio/mp3", // 类型
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖 Video.js 无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 时间分割线
          durationDisplay: false, // 总时间
          remainingTimeDisplay: false, // 剩余播放时间
          progressControl: false, // 进度条
          fullscreenToggle: false, // 全屏按钮
        },
      },
      playState: false,
      value: 0,
      totalTime: 0,
      player: null,
      duration: 0,
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
  },
  mounted() {
    var musicDom = this.$refs.videoPlayer;

    let that = this;

    musicDom.onloadedmetadata = function () {
      that.totalTime = musicDom.duration;
    };
  },
  methods: {
    // canplay(player) {
    //   console.log(player);
    //   this.player = player;
    //   // this.totalTime = player.duration();
    //   // console.log(this.totalTime);
    // },
    onPlayerPlay(e) {
      console.log(e);
    },
    play() {
      if (this.playState) {
        this.playState = false;
        this.$refs.videoPlayer.pause();
      } else {
        this.playState = true;
        this.$refs.videoPlayer.play();
      }
    },

    // 拖动事件
    onChange(e) {
      let number = e;
      this.$refs.videoPlayer.currentTime = number;
    },
    onPlayerTimeupdate(e) {
      this.value += 0.25;
    },
    onPlayerEnded() {
      this.playState = false;
      this.value = 0;
      // this.$refs.videoPlayer.reset();
    },

    getTime(time) {
      let m = parseInt(time / 60);
      let s = time % 60;
      let date = (m > 9 ? m : "0" + m) + ":" + (s > 9 ? s : "0" + s);
      return date;
    },
  },
};
</script>
<style scoped lang='scss'>
div {
  box-sizing: border-box;
}
.video-content {
  display: flex;
  flex-direction: column;
  padding: 0 14px;
  width: 100%;
  height: 100vh;
  .image-bg {
    padding: 100px 0 30px 0;
    text-align: center;
    width: 100%;
    img {
      width: 60%;
      // box-shadow: 0px 3px 8px 2px rgba(0, 0, 0, 0.5);
    }
  }
  .title {
    width: 100%;
    padding-bottom: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  .abstract {
    padding: 20px 14px 8px 0px;
    span {
      padding: 8px 8px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      background: linear-gradient(
        to top,
        rgb(212, 234, 248) 0%,
        rgb(212, 234, 248) 50%,
        white 51%,
        white 100%
      );
    }
  }
  .remark {
    margin-top: 10px;
    padding: 0 14px 10px 6px;
    width: 100%;
    height: calc(100% - 550px);
    overflow: auto;
    font-size: 16px;
    color: #666;
  }
  .slider {
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 20px;
    .time {
      text-align: right;
      width: 66px;
    }
    .time-left {
      text-align: left;
      width: 70px;
    }
  }
  .buttn-box {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 40px;
    .ply-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: linear-gradient(90deg, #2e9adb 0%, #77c1ee 100%);
      img {
        width: 14px;
      }
    }
  }
}
</style>